import { makeStyles } from "tss-react/mui";

export const customDataTableStyle = makeStyles()({
    tablePaginationStyle: {
        width: "calc(100% - 25px)",
        position: "fixed",
        bottom: "25px",
        right: "60px"
    }
})